import api from "../../axios/api.js";

export class CommunicationsUnitsService {
  async getCommunicationUnits() {
    const data = await api.get("CommunicationUnits");
    return data;
  }
}
